import React, { useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'
import styles from './TestimonialsSection.module.scss'

function TestimonialCard({ testimonial }) {
    const [isExpanded, setIsExpanded] = useState(false)
    const testimonialId = `testimonial-${testimonial.employer_name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`

    return (
        <figure className={styles.card}>
            <div className={styles.cardTop}>
                {testimonial.logo ? (
                    <div className={styles.logoFrame}>
                        <img className={styles.logo} src={testimonial.logo} alt={testimonial.logo_alt || testimonial.employer_name} />
                    </div>
                ) : (
                    <div className={styles.logoFrame}>
                        <div className={styles.logoFallback} aria-hidden="true">{testimonial.employer_name.charAt(0)}</div>
                    </div>
                )}
                <svg className={styles.quoteMark} aria-hidden="true" width="44" height="36" viewBox="0 0 44 36" fill="#02A0E9">
                    <path d="M0 36V21C0 9 6 2 18 0l2 5c-7 2-10 6-10 12h8v19H0zm24 0V21c0-12 6-19 18-21l2 5c-7 2-10 6-10 12h8v19H24z" />
                </svg>
            </div>
            <blockquote className={styles.quote}>“{testimonial.quote}”</blockquote>
            <figcaption className={styles.caption}>
                <span className={styles.organisation}>{testimonial.employer_name}</span>
                {(testimonial.category || testimonial.partner_year) && (
                    <span className={styles.meta}>
                        {testimonial.category}
                        {testimonial.category && testimonial.partner_year ? ' · ' : ''}
                        {testimonial.partner_year && `Partner since ${testimonial.partner_year}`}
                    </span>
                )}
            </figcaption>
            <div className={styles.more}>
                <button
                    type="button"
                    className={styles.toggle}
                    aria-expanded={isExpanded}
                    aria-controls={testimonialId}
                    onClick={() => setIsExpanded((expanded) => !expanded)}
                >
                    <span>{isExpanded ? 'Show less' : 'Read full testimonial'}</span>
                    <IoIosArrowDown aria-hidden="true" />
                </button>
                {isExpanded && (
                    <div id={testimonialId} className={styles.fullTestimonial} dangerouslySetInnerHTML={{ __html: testimonial.full_testimonial }} />
                )}
            </div>
        </figure>
    )
}

function TestimonialsSection({ section }) {
    if (!section?.testimonials?.length) {
        return null
    }

    return (
        <section className={styles.wrapper} aria-labelledby="testimonials-title">
            <div className={styles.inner}>
                <div className={styles.head}>
                    <div className={styles.titleRow}>
                        <span className={styles.rule} aria-hidden="true" />
                        <h2 id="testimonials-title" className={styles.title}>{section.title}</h2>
                        <span className={styles.rule} aria-hidden="true" />
                    </div>
                    <p className={styles.intro}>{section.intro || 'Recruiters across the UK use The Diversity Job Network to reach a wider, more diverse pool of candidates.'}</p>
                </div>
                <div className={styles.grid}>
                    {section.testimonials.map((testimonial) => (
                        <TestimonialCard key={testimonial.employer_name} testimonial={testimonial} />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default TestimonialsSection
